import { render, staticRenderFns } from "./SearchDoctor.vue?vue&type=template&id=494216be&"
import script from "./SearchDoctor.vue?vue&type=script&lang=js&"
export * from "./SearchDoctor.vue?vue&type=script&lang=js&"
import style0 from "./SearchDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports